import globalAxios from 'axios';
import { B as BaseAPI, D as DUMMY_BASE_URL, s as setBearerAuthToObject, b as setSearchParams, c as serializeDataIfNeeded, t as toPathString, o as operationServerMap, d as createRequestFunction, e as BASE_PATH } from '../common-BuhUSHAi.js';

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * FAQsApi - axios parameter creator
 * @export
 */
const FAQsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFAQSEntries: async (id, options = {}) => {
            const localVarPath = `/v1/FAQs/DeleteFAQSEntries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFAQSMain: async (id, options = {}) => {
            const localVarPath = `/v1/FAQs/DeleteFAQSMain`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFAQSEntries: async (id, options = {}) => {
            const localVarPath = `/v1/FAQs/GetAllFAQSEntries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [id]
         * @param {number} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByEntityType: async (id, type, options = {}) => {
            const localVarPath = `/v1/FAQs/GetByEntityType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [type]
         * @param {number} [id]
         * @param {boolean} [isEntityAction]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFAQSMain: async (type, id, isEntityAction, options = {}) => {
            const localVarPath = `/v1/FAQs/GetFAQSMain`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            if (isEntityAction !== undefined) {
                localVarQueryParameter['isEntityAction'] = isEntityAction;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {number} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFAQs: async (id, type, options = {}) => {
            const localVarPath = `/v1/FAQs/GetFAQs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [type]
         * @param {number} [id]
         * @param {string} [path]
         * @param {string} [section]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFAQsmultiple: async (type, id, path, section, options = {}) => {
            const localVarPath = `/v1/FAQs/GetFAQsmultiple`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }
            if (section !== undefined) {
                localVarQueryParameter['section'] = section;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {FAQToken} [FAQToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insert: async (FAQToken, options = {}) => {
            const localVarPath = `/v1/FAQs/Insert`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(FAQToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {FAQSEntryToken} [FAQSEntryToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertFAQSEntries: async (FAQSEntryToken, options = {}) => {
            const localVarPath = `/v1/FAQs/InsertFAQSEntries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(FAQSEntryToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {FAQSMainToken} [FAQSMainToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertFAQSMain: async (FAQSMainToken, options = {}) => {
            const localVarPath = `/v1/FAQs/InsertFAQSMain`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(FAQSMainToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id, options = {}) => {
            const localVarPath = `/v1/FAQs/Delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {FAQToken} [FAQToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (FAQToken, options = {}) => {
            const localVarPath = `/v1/FAQs/Update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(FAQToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {FAQSEntryToken} [FAQSEntryToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFAQSEntries: async (FAQSEntryToken, options = {}) => {
            const localVarPath = `/v1/FAQs/UpdateFAQSEntries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(FAQSEntryToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {FAQSMainToken} [FAQSMainToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFAQSMain: async (FAQSMainToken, options = {}) => {
            const localVarPath = `/v1/FAQs/UpdateFAQSMain`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(FAQSMainToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * FAQsApi - functional programming interface
 * @export
 */
const FAQsApiFp = function (configuration) {
    const localVarAxiosParamCreator = FAQsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFAQSEntries(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFAQSEntries(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FAQsApi.deleteFAQSEntries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFAQSMain(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFAQSMain(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FAQsApi.deleteFAQSMain']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllFAQSEntries(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllFAQSEntries(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FAQsApi.getAllFAQSEntries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [id]
         * @param {number} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByEntityType(id, type, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByEntityType(id, type, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FAQsApi.getByEntityType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [type]
         * @param {number} [id]
         * @param {boolean} [isEntityAction]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFAQSMain(type, id, isEntityAction, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFAQSMain(type, id, isEntityAction, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FAQsApi.getFAQSMain']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {number} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFAQs(id, type, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFAQs(id, type, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FAQsApi.getFAQs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [type]
         * @param {number} [id]
         * @param {string} [path]
         * @param {string} [section]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFAQsmultiple(type, id, path, section, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFAQsmultiple(type, id, path, section, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FAQsApi.getFAQsmultiple']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {FAQToken} [FAQToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async insert(FAQToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.insert(FAQToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FAQsApi.insert']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {FAQSEntryToken} [FAQSEntryToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async insertFAQSEntries(FAQSEntryToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.insertFAQSEntries(FAQSEntryToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FAQsApi.insertFAQSEntries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {FAQSMainToken} [FAQSMainToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async insertFAQSMain(FAQSMainToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.insertFAQSMain(FAQSMainToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FAQsApi.insertFAQSMain']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FAQsApi.remove']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {FAQToken} [FAQToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(FAQToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(FAQToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FAQsApi.update']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {FAQSEntryToken} [FAQSEntryToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFAQSEntries(FAQSEntryToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFAQSEntries(FAQSEntryToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FAQsApi.updateFAQSEntries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {FAQSMainToken} [FAQSMainToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFAQSMain(FAQSMainToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFAQSMain(FAQSMainToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FAQsApi.updateFAQSMain']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * FAQsApi - factory interface
 * @export
 */
const FAQsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = FAQsApiFp(configuration);
    return {
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFAQSEntries(id, options) {
            return localVarFp.deleteFAQSEntries(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFAQSMain(id, options) {
            return localVarFp.deleteFAQSMain(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFAQSEntries(id, options) {
            return localVarFp.getAllFAQSEntries(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [id]
         * @param {number} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByEntityType(id, type, options) {
            return localVarFp.getByEntityType(id, type, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [type]
         * @param {number} [id]
         * @param {boolean} [isEntityAction]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFAQSMain(type, id, isEntityAction, options) {
            return localVarFp.getFAQSMain(type, id, isEntityAction, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {number} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFAQs(id, type, options) {
            return localVarFp.getFAQs(id, type, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [type]
         * @param {number} [id]
         * @param {string} [path]
         * @param {string} [section]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFAQsmultiple(type, id, path, section, options) {
            return localVarFp.getFAQsmultiple(type, id, path, section, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {FAQToken} [FAQToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insert(FAQToken, options) {
            return localVarFp.insert(FAQToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {FAQSEntryToken} [FAQSEntryToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertFAQSEntries(FAQSEntryToken, options) {
            return localVarFp.insertFAQSEntries(FAQSEntryToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {FAQSMainToken} [FAQSMainToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertFAQSMain(FAQSMainToken, options) {
            return localVarFp.insertFAQSMain(FAQSMainToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id, options) {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {FAQToken} [FAQToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(FAQToken, options) {
            return localVarFp.update(FAQToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {FAQSEntryToken} [FAQSEntryToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFAQSEntries(FAQSEntryToken, options) {
            return localVarFp.updateFAQSEntries(FAQSEntryToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {FAQSMainToken} [FAQSMainToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFAQSMain(FAQSMainToken, options) {
            return localVarFp.updateFAQSMain(FAQSMainToken, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * FAQsApi - object-oriented interface
 * @export
 * @class FAQsApi
 * @extends {BaseAPI}
 */
class FAQsApi extends BaseAPI {
    /**
     *
     * @summary  (Auth roles: System)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FAQsApi
     */
    deleteFAQSEntries(id, options) {
        return FAQsApiFp(this.configuration).deleteFAQSEntries(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: System)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FAQsApi
     */
    deleteFAQSMain(id, options) {
        return FAQsApiFp(this.configuration).deleteFAQSMain(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: System)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FAQsApi
     */
    getAllFAQSEntries(id, options) {
        return FAQsApiFp(this.configuration).getAllFAQSEntries(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [id]
     * @param {number} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FAQsApi
     */
    getByEntityType(id, type, options) {
        return FAQsApiFp(this.configuration).getByEntityType(id, type, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: System)
     * @param {number} [type]
     * @param {number} [id]
     * @param {boolean} [isEntityAction]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FAQsApi
     */
    getFAQSMain(type, id, isEntityAction, options) {
        return FAQsApiFp(this.configuration).getFAQSMain(type, id, isEntityAction, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: System)
     * @param {number} [id]
     * @param {number} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FAQsApi
     */
    getFAQs(id, type, options) {
        return FAQsApiFp(this.configuration).getFAQs(id, type, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [type]
     * @param {number} [id]
     * @param {string} [path]
     * @param {string} [section]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FAQsApi
     */
    getFAQsmultiple(type, id, path, section, options) {
        return FAQsApiFp(this.configuration).getFAQsmultiple(type, id, path, section, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: System)
     * @param {FAQToken} [FAQToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FAQsApi
     */
    insert(FAQToken, options) {
        return FAQsApiFp(this.configuration).insert(FAQToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: System)
     * @param {FAQSEntryToken} [FAQSEntryToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FAQsApi
     */
    insertFAQSEntries(FAQSEntryToken, options) {
        return FAQsApiFp(this.configuration).insertFAQSEntries(FAQSEntryToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: System)
     * @param {FAQSMainToken} [FAQSMainToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FAQsApi
     */
    insertFAQSMain(FAQSMainToken, options) {
        return FAQsApiFp(this.configuration).insertFAQSMain(FAQSMainToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: System)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FAQsApi
     */
    remove(id, options) {
        return FAQsApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: System)
     * @param {FAQToken} [FAQToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FAQsApi
     */
    update(FAQToken, options) {
        return FAQsApiFp(this.configuration).update(FAQToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: System)
     * @param {FAQSEntryToken} [FAQSEntryToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FAQsApi
     */
    updateFAQSEntries(FAQSEntryToken, options) {
        return FAQsApiFp(this.configuration).updateFAQSEntries(FAQSEntryToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: System)
     * @param {FAQSMainToken} [FAQSMainToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FAQsApi
     */
    updateFAQSMain(FAQSMainToken, options) {
        return FAQsApiFp(this.configuration).updateFAQSMain(FAQSMainToken, options).then((request) => request(this.axios, this.basePath));
    }
}

export { FAQsApi, FAQsApiAxiosParamCreator, FAQsApiFactory, FAQsApiFp };
//# sourceMappingURL=faqs-api.js.map
